import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../primitives/ids.js";
import { TraceContextSchema } from "./trace.js";
import { ArreBatchIdSchema, ArreBatchItemIdSchema } from "./csv-arre.js";
import { ImportDraftIdSchema } from "./import-draft.js";
/** import-extract-job-payload.v1.0 — worker job for single snapshot import extraction. */
export const ExtractImportDraftJobPayloadV1Schema = z
    .object({
    schemaVersion: z.literal("import-extract-job-payload.v1.0"),
    jobKind: z.literal("EXTRACT_IMPORT_DRAFT"),
    importDraftId: ImportDraftIdSchema,
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    snapshotId: z.string().min(1),
    sourceUrl: z.string().url(),
    trace: TraceContextSchema,
})
    .strict();
/** csv-arre-batch-job-payload.v1.0 — worker job for CSV/ARRE portfolio batch. */
export const ProcessCsvArreBatchJobPayloadV1Schema = z
    .object({
    schemaVersion: z.literal("csv-arre-batch-job-payload.v1.0"),
    jobKind: z.literal("PROCESS_CSV_ARRE_BATCH"),
    batchId: ArreBatchIdSchema,
    agencyId: AgencyIdSchema,
    itemIds: z.array(ArreBatchItemIdSchema).min(1).max(50),
    trace: TraceContextSchema,
})
    .strict();
export const IMPORT_EXTRACT_QUEUE_NAME = "tier0-import-extract";
export const CSV_ARRE_BATCH_QUEUE_NAME = "tier0-csv-arre-batch";
export function importExtractEnqueueJobId(importDraftId) {
    return `enr:import-extract:${importDraftId}`;
}
export function csvArreBatchEnqueueJobId(batchId) {
    return `enr:csv-arre:${batchId}`;
}
//# sourceMappingURL=import-job-payload.js.map